export { default } from './categories.vue'
